export default "__VITE_ASSET__4U8e9ywD__"